module.exports = __webpack_public_path__ + "static/media/YF40_1.12e56436.jpg";